/* PipiPanda Shopify Theme — Interactions
   Converted from V3 static site to Shopify Cart API */
(function () {
  'use strict';

  var product = window.PipiPanda && window.PipiPanda.product;
  var variants = window.PipiPanda && window.PipiPanda.variants;
  var images = window.PipiPanda && window.PipiPanda.images;

  var $ = function(sel) { return document.querySelector(sel); };
  var $$ = function(sel) { return document.querySelectorAll(sel); };

  /* ==========================================
     GLOBAL: HELPERS
     ========================================== */
  function fmt(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0\u20ac';
  }

  function setActive(container, selector, activeEl) {
    if (!container) return;
    container.querySelectorAll(selector).forEach(function(el) {
      el.classList.remove('active');
      if (el.getAttribute('role') === 'radio') el.setAttribute('aria-checked', 'false');
    });
    activeEl.classList.add('active');
    if (activeEl.getAttribute('role') === 'radio') activeEl.setAttribute('aria-checked', 'true');
  }

  /* ==========================================
     GLOBAL: CART DOM REFS
     ========================================== */
  var cartBadge   = $('#cart-badge');
  var cartDrawer  = $('#cart-drawer');
  var cartOverlay = $('#cart-overlay');
  var cartItems   = $('#cart-items');
  var cartTotal   = $('#cart-total');
  var cartNote    = $('#cart-note');

  /* ==========================================
     GLOBAL: CART API + RENDER
     ========================================== */
  function removeFromCart(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function(res) {
      if (!res.ok) {
        return res.json().then(function(data) {
          throw new Error(data.description || 'Fehler beim Entfernen');
        });
      }
      return res.json();
    })
    .then(function() { return refreshCart(); })
    .catch(function(err) {
      console.error('Cart remove error:', err);
      return refreshCart();
    });
  }

  function refreshCart() {
    return fetch('/cart.js')
      .then(function(res) {
        if (!res.ok) throw new Error('Cart fetch failed: ' + res.status);
        return res.json();
      })
      .then(function(cart) { renderCart(cart); })
      .catch(function(err) { console.error('Cart refresh error:', err); });
  }

  function renderCart(cart) {
    if (!cartItems) return;

    if (cartBadge) cartBadge.textContent = cart.item_count;

    if (cart.item_count === 0) {
      cartItems.innerHTML = '<p class="cart-empty">Dein Warenkorb ist leer</p>';
      if (cartTotal) cartTotal.textContent = fmt(0);
      if (cartNote) cartNote.textContent = '';
      var cartSavedEmpty = document.getElementById('cart-saved');
      if (cartSavedEmpty) { cartSavedEmpty.style.display = 'none'; cartSavedEmpty.textContent = ''; }
      var cartCompareEmpty = document.getElementById('cart-compare');
      if (cartCompareEmpty) { cartCompareEmpty.style.display = 'none'; cartCompareEmpty.innerHTML = ''; }
      return;
    }

    if (cartTotal) cartTotal.textContent = fmt(cart.total_price);

    /* Gespart + Streichpreis (aus Varianten compare_at_price) */
    var cartSaved = document.getElementById('cart-saved');
    var cartCompare = document.getElementById('cart-compare');
    var totalSaved = 0;
    var totalOriginal = 0;
    var ppVariants = window.PipiPanda && window.PipiPanda.variants;
    cart.items.forEach(function(item) {
      var compareAt = 0;
      if (ppVariants) {
        for (var vi = 0; vi < ppVariants.length; vi++) {
          if (ppVariants[vi].id === item.variant_id && ppVariants[vi].compare_at_price) {
            compareAt = ppVariants[vi].compare_at_price * item.quantity;
            break;
          }
        }
      }
      if (compareAt > item.final_line_price) {
        totalOriginal += compareAt;
        totalSaved += compareAt - item.final_line_price;
      } else {
        totalOriginal += item.final_line_price;
      }
    });
    if (cartCompare) {
      if (totalSaved > 0) {
        var discountPct = Math.round(totalSaved / totalOriginal * 100);
        cartCompare.innerHTML = '<span class="drawer-compare-price">' + fmt(totalOriginal) + '</span><span class="drawer-compare-badge">' + discountPct + '% gespart</span>';
        cartCompare.style.display = '';
      } else {
        cartCompare.style.display = 'none';
      }
    }
    if (cartSaved) {
      if (totalSaved > 0) {
        cartSaved.textContent = 'Du sparst ' + fmt(totalSaved);
        cartSaved.style.display = '';
      } else {
        cartSaved.style.display = 'none';
      }
    }

    /* Free shipping note */
    var rawThreshold = window.PipiPanda && window.PipiPanda.freeShippingThreshold;
    var threshold = (parseInt(rawThreshold, 10) || 49) * 100;
    if (cartNote) {
      if (cart.total_price >= threshold) {
        cartNote.textContent = 'Kostenloser Versand \u2713';
      } else {
        cartNote.textContent = 'Noch ' + fmt(threshold - cart.total_price) + ' bis zum kostenlosen Versand';
      }
    }

    cartItems.innerHTML = '';
    var kollektionImg = 'https://cdn.shopify.com/s/files/1/1001/5961/9401/files/kollektion-faecher.jpg?v=1776221438';

    cart.items.forEach(function(item) {
      var div = document.createElement('div');
      div.className = 'cart-item';
      div.dataset.cartKey = item.key;

      var img = document.createElement('img');
      img.className = 'cart-item-img';
      img.src = kollektionImg;
      img.alt = item.title;
      img.width = 80; img.height = 80;
      div.appendChild(img);

      var info = document.createElement('div');
      info.className = 'cart-item-info';
      var name = document.createElement('span');
      name.className = 'cart-item-name';
      name.textContent = item.product_title;
      info.appendChild(name);
      var meta = document.createElement('span');
      meta.className = 'cart-item-meta';
      meta.textContent = item.variant_title;
      info.appendChild(meta);
      if (item.properties) {
        for (var key in item.properties) {
          if (!item.properties[key]) continue;
          if (key === 'Muster') {
            var musterVal = item.properties[key].trim();
            if (musterVal.length > 0) {
              var patternsWrap = document.createElement('div');
              patternsWrap.className = 'cart-item-patterns';
              var patternLabel = document.createElement('span');
              patternLabel.className = 'cart-item-meta';
              patternLabel.textContent = key + ':';
              patternsWrap.appendChild(patternLabel);
              var pills = document.createElement('div');
              pills.className = 'cart-pattern-pills';
              var ppImages = window.PipiPanda && window.PipiPanda.images;
              /* Also try product images from cart item */
              var patternNames = musterVal.split(', ');
              patternNames.forEach(function(n) {
                var trimmed = n.trim();
                if (!trimmed) return;
                var pill = document.createElement('span');
                pill.className = 'cart-pattern-pill';
                var thumbUrl = '';
                if (ppImages) {
                  for (var pi = 0; pi < ppImages.length; pi++) {
                    if (ppImages[pi].alt === trimmed) { thumbUrl = ppImages[pi].thumb; break; }
                  }
                }
                /* Fallback: try matching from cart item images */
                if (!thumbUrl && item.image) {
                  thumbUrl = '';
                }
                if (thumbUrl) {
                  var pillImg = document.createElement('img');
                  pillImg.src = thumbUrl;
                  pillImg.alt = trimmed;
                  pillImg.width = 24;
                  pillImg.height = 24;
                  pillImg.className = 'cart-pattern-pill-img';
                  pill.appendChild(pillImg);
                }
                var pillText = document.createElement('span');
                pillText.textContent = trimmed;
                pill.appendChild(pillText);
                pills.appendChild(pill);
              });
              patternsWrap.appendChild(pills);
              info.appendChild(patternsWrap);
            }
          } else {
            var propLine = document.createElement('span');
            propLine.className = 'cart-item-meta';
            propLine.textContent = key + ': ' + item.properties[key];
            info.appendChild(propLine);
          }
        }
      }
      var removeBtn = document.createElement('button');
      removeBtn.className = 'cart-item-remove';
      removeBtn.dataset.cartKey = item.key;
      removeBtn.textContent = 'Entfernen';
      info.appendChild(removeBtn);
      div.appendChild(info);

      var price = document.createElement('span');
      price.className = 'cart-item-price';
      price.textContent = fmt(item.final_line_price);
      div.appendChild(price);

      cartItems.appendChild(div);
    });
  }

  /* ==========================================
     GLOBAL: BODY SCROLL LOCK (shared)
     ========================================== */
  var scrollLockCount = 0;
  var scrollLockSavedY = 0;

  function lockScroll() {
    if (scrollLockCount === 0) {
      scrollLockSavedY = window.scrollY;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = '-' + scrollLockSavedY + 'px';
    }
    scrollLockCount++;
  }

  function unlockScroll() {
    scrollLockCount--;
    if (scrollLockCount <= 0) {
      scrollLockCount = 0;
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.top = '';
      window.scrollTo(0, scrollLockSavedY);
    }
  }

  /* ==========================================
     GLOBAL: CART DRAWER OPEN/CLOSE
     ========================================== */
  var cartTriggerEl = null;

  function openCart() {
    if (!cartDrawer) return;
    cartTriggerEl = document.activeElement;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) {
      cartOverlay.classList.add('open');
      cartOverlay.setAttribute('aria-hidden', 'false');
    }
    lockScroll();
    setTimeout(function() {
      var closeBtn = $('#cart-close');
      if (closeBtn) closeBtn.focus();
    }, 100);
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartOverlay) {
      cartOverlay.classList.remove('open');
      cartOverlay.setAttribute('aria-hidden', 'true');
    }
    unlockScroll();
    if (cartTriggerEl && cartTriggerEl.focus) {
      cartTriggerEl.focus();
    } else {
      var toggle = $('#cart-toggle');
      if (toggle) toggle.focus();
    }
  }

  /* GLOBAL: Cart toggle, close, overlay, escape, focus trap, remove handler */
  var cartToggle = $('#cart-toggle');
  if (cartToggle) {
    cartToggle.addEventListener('click', function() {
      if (cartDrawer && cartDrawer.classList.contains('open')) closeCart();
      else { refreshCart().then(function() { openCart(); }).catch(function() { openCart(); }); }
    });
  }

  var cartClose = $('#cart-close');
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    var lb = document.getElementById('review-lightbox');
    if (lb && lb.classList.contains('open')) return;
    if (cartDrawer && cartDrawer.classList.contains('open')) closeCart();
  });

  if (cartDrawer) {
    cartDrawer.addEventListener('keydown', function(e) {
      if (e.key !== 'Tab') return;
      var focusable = cartDrawer.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])');
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    });
  }

  if (cartItems) {
    cartItems.addEventListener('click', function(e) {
      var removeBtn = e.target.closest('.cart-item-remove');
      if (!removeBtn) return;
      removeFromCart(removeBtn.dataset.cartKey);
    });
  }

  /* ==========================================
     GLOBAL: REVIEW LIGHTBOX
     ========================================== */
  var lightbox = document.getElementById('review-lightbox');
  var lightboxImg = document.getElementById('review-lightbox-img');
  var lightboxClose = document.getElementById('review-lightbox-close');

  if (lightbox) {
    var lightboxTrigger = null;

    document.addEventListener('click', function(e) {
      var thumb = e.target.closest('.review-thumb');
      if (!thumb) return;
      var src = thumb.dataset.lightboxSrc;
      if (!src || !lightboxImg) return;
      lightboxTrigger = thumb;
      lightboxImg.src = src;
      lightboxImg.alt = thumb.querySelector('img') ? thumb.querySelector('img').alt : '';
      lightbox.classList.add('open');
      lightbox.setAttribute('aria-hidden', 'false');
      lockScroll();
      if (lightboxClose) lightboxClose.focus();
    });

    function closeLightbox() {
      lightbox.classList.remove('open');
      lightbox.setAttribute('aria-hidden', 'true');
      unlockScroll();
      lightboxImg.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
      if (lightboxTrigger && document.contains(lightboxTrigger)) {
        lightboxTrigger.focus();
      } else {
        var fallback = document.querySelector('.review-thumb') || document.getElementById('bewertungen');
        if (fallback && fallback.focus) fallback.focus();
      }
      lightboxTrigger = null;
    }

    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    lightbox.querySelector('.review-lightbox-overlay').addEventListener('click', closeLightbox);
    document.addEventListener('keydown', function(e) {
      if (!lightbox.classList.contains('open')) return;
      if (e.key === 'Escape') { closeLightbox(); return; }
      if (e.key === 'Tab') {
        e.preventDefault();
        if (lightboxClose) lightboxClose.focus();
      }
    });
  }

  /* ==========================================
     GLOBAL: INIT (runs on all pages)
     ========================================== */
  function initGlobal() {
    /* Back to top button */
    var backToTop = document.getElementById('back-to-top');
    if (backToTop) {
      window.addEventListener('scroll', function() {
        backToTop.classList.toggle('visible', window.scrollY > 600);
      }, { passive: true });
    }

    /* Sticky header shadow */
    var hdr = $('#site-header');
    if (hdr) {
      window.addEventListener('scroll', function() {
        hdr.classList.toggle('scrolled', window.scrollY > 10);
      }, { passive: true });
    }

    /* Scroll reveal */
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var revealObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

      document.querySelectorAll('.kollektion-strip, .moment-break, .reveal').forEach(function(el) {
        el.classList.add('reveal');
        revealObserver.observe(el);
      });
    }
  }

  initGlobal();

  /* ==========================================
     PRODUCT ONLY: Everything below requires product data
     ========================================== */
  if (!product) return;

  var state = {
    size: 'M',
    bundle: '6er-Pack',
    patternHandle: images && images[0] ? images[0].handle : '',
    patternName: images && images[0] ? images[0].alt : '',
    patternSrc: images && images[0] ? images[0].src : '',
    mixMode: 'custom',
    mixSelections: [],
    editingSlot: -1
  };

  var BUNDLE_META = {
    '3er-Pack': { qty: 3, context: 'pro St\u00fcck \u00b7 3 St\u00fcck f\u00fcr ' },
    '6er-Pack': { qty: 6, context: 'pro St\u00fcck \u00b7 6 St\u00fcck f\u00fcr ' },
    '9er-Pack': { qty: 9, context: 'pro St\u00fcck \u00b7 9 St\u00fcck f\u00fcr ' }
  };

  var mainImage    = $('#main-image');
  var patternLabel = $('#pattern-name');
  var priceMain    = $('#price-main');
  var priceCtx     = $('#price-context');
  var variantInput = $('#variant-id');
  var mixProperty      = $('#mix-property');
  var mixModeProperty  = $('#mix-mode-property');
  var productForm      = $('#product-form');

  /* ==========================================
     PRODUCT: VARIANT LOGIC
     ========================================== */
  function setupRadiogroupKeys(container, selector) {
    if (!container) return;
    container.addEventListener('keydown', function(e) {
      if (['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].indexOf(e.key) === -1) return;
      e.preventDefault();
      var items = Array.from(container.querySelectorAll(selector));
      var idx = items.indexOf(document.activeElement);
      if (idx === -1) return;
      var next = e.key === 'ArrowRight' || e.key === 'ArrowDown'
        ? items[(idx + 1) % items.length]
        : items[(idx - 1 + items.length) % items.length];
      next.focus();
      next.click();
    });
  }

  function findVariant() {
    if (!variants) return null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.option1 === state.size && v.option2 === state.bundle) {
        return v;
      }
    }
    return variants[0];
  }

  function updateVariant() {
    var v = findVariant();
    if (!v) return;

    variantInput.value = v.id;

    var meta = BUNDLE_META[state.bundle];
    var unitPrice = v.price / (meta ? meta.qty : 1);
    priceMain.textContent = fmt(unitPrice);
    if (meta) {
      priceCtx.textContent = meta.context + fmt(v.price);
    }

    /* Streichpreis + Save Badge */
    var priceCompare = $('#price-compare');
    var priceSaveBadge = $('#price-save-badge');
    if (v.compare_at_price && v.compare_at_price > v.price) {
      var unitCompare = v.compare_at_price / (meta ? meta.qty : 1);
      var discountPct = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100);
      if (priceCompare) priceCompare.textContent = fmt(unitCompare);
      if (priceSaveBadge) priceSaveBadge.textContent = discountPct + '% SPAREN';
    } else {
      if (priceCompare) priceCompare.textContent = '';
      if (priceSaveBadge) priceSaveBadge.textContent = '';
    }

    /* Update bundle card prices */
    $$('.bundle-card').forEach(function(card) {
      var bundleName = card.dataset.bundle;
      for (var j = 0; j < variants.length; j++) {
        if (variants[j].option1 === state.size && variants[j].option2 === bundleName) {
          var bv = variants[j];
          var bMeta = BUNDLE_META[bundleName];
          var bUnit = bv.price / (bMeta ? bMeta.qty : 1);
          var totalEl = card.querySelector('[data-bundle-price]');
          var unitEl = card.querySelector('[data-bundle-unit]');
          if (totalEl) totalEl.textContent = fmt(bv.price);
          if (unitEl) unitEl.textContent = fmt(bUnit) + ' / St\u00fcck';
          break;
        }
      }
    });

    /* Update add-to-cart button */
    var addBtn = $('#add-to-cart');
    if (addBtn) {
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
    }
  }

  /* ==========================================
     PRODUCT: GALLERY
     ========================================== */
  function switchPattern(handle, name, src) {
    if (state.patternHandle === handle) return;
    state.patternHandle = handle;
    state.patternName = name;
    state.patternSrc = src;

    if (patternLabel) patternLabel.textContent = name;

    var carousel = document.getElementById('gallery-carousel');
    if (carousel) {
      var slides = carousel.querySelectorAll('.gallery-slide');
      var thumbs = document.querySelectorAll('.gallery-thumb');
      slides.forEach(function(slide, i) {
        var img = slide.querySelector('img');
        if (img && img.alt === name) {
          slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          slides.forEach(function(s, j) { s.classList.toggle('active', j === i); });
          thumbs.forEach(function(t, j) { t.classList.toggle('active', j === i); });
        }
      });
    }

    $$('.swatch').forEach(function(s) {
      var isActive = s.dataset.pattern === handle;
      s.classList.toggle('active', isActive);
      s.setAttribute('aria-checked', isActive ? 'true' : 'false');
    });
  }

  /* Thumbnail clicks */
  var thumbContainer = $('.gallery-thumbs');
  if (thumbContainer) {
    thumbContainer.addEventListener('click', function(e) {
      var thumb = e.target.closest('.gallery-thumb');
      if (!thumb) return;
      var idx = parseInt(thumb.dataset.index, 10);
      thumbContainer.querySelectorAll('.gallery-thumb').forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      var slides = document.querySelectorAll('.gallery-slide');
      slides.forEach(function(s, i) { s.classList.toggle('active', i === idx); });
      if (slides[idx]) {
        slides[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    });
  }

  /* Carousel scroll → sync active thumb on swipe */
  var carouselEl = document.getElementById('gallery-carousel');
  if (carouselEl) {
    var scrollTimer;
    carouselEl.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        var allSlides = carouselEl.querySelectorAll('.gallery-slide');
        var allThumbs = document.querySelectorAll('.gallery-thumb');
        if (!allSlides.length) return;
        var slideWidth = allSlides[0].offsetWidth + 12;
        var activeIdx = Math.round(carouselEl.scrollLeft / slideWidth);
        allSlides.forEach(function(s, i) { s.classList.toggle('active', i === activeIdx); });
        allThumbs.forEach(function(t, i) { t.classList.toggle('active', i === activeIdx); });
      }, 50);
    }, { passive: true });
  }

  /* Swatches */
  var swatchContainer = $('.swatches');
  if (swatchContainer) {
    swatchContainer.addEventListener('click', function(e) {
      var swatch = e.target.closest('.swatch');
      if (!swatch) return;
      switchPattern(swatch.dataset.pattern, swatch.dataset.name, swatch.dataset.src);
    });
  }

  /* ==========================================
     PRODUCT: SIZE + BUNDLE SELECTION
     ========================================== */
  var sizesContainer = $('.sizes');
  if (sizesContainer) {
    sizesContainer.addEventListener('click', function(e) {
      var btn = e.target.closest('.size-btn');
      if (!btn) return;
      state.size = btn.dataset.size;
      setActive(btn.parentElement, '.size-btn', btn);
      updateVariant();
    });
  }

  var bundlesContainer = $('.bundles');
  if (bundlesContainer) {
    bundlesContainer.addEventListener('click', function(e) {
      var card = e.target.closest('.bundle-card');
      if (!card) return;
      state.bundle = card.dataset.bundle;
      setActive(card.parentElement, '.bundle-card', card);
      updateVariant();
      buildMixSlots();
    });
  }

  /* ==========================================
     PRODUCT: PATTERN MIX SELECTOR
     ========================================== */
  function getAutoMix(count) {
    var mix = [];
    if (!images) return mix;
    for (var i = 0; i < Math.min(count, images.length); i++) mix.push(images[i]);
    while (mix.length < count && images.length > 0) {
      mix.push(images[mix.length % images.length]);
    }
    return mix;
  }

  function buildMixSlots() {
    var meta = BUNDLE_META[state.bundle];
    var qty = meta ? meta.qty : 6;
    var prev = state.mixSelections || [];

    if (state.mixMode === 'custom' && prev.length > 0) {
      var kept = prev.slice(0, qty);
      var auto = getAutoMix(qty);
      state.mixSelections = kept.length >= qty ? kept : kept.concat(auto.slice(kept.length));
    } else {
      state.mixSelections = getAutoMix(qty);
    }
    state.editingSlot = -1;
    renderMixSlots();
    updateMixProperty();
  }

  function renderMixSlots() {
    var slotsEl = $('#mix-slots');
    var pickerEl = $('#mix-picker');
    var hintEl = $('.mix-hint');
    if (!slotsEl) return;

    var total = state.mixSelections.length;

    slotsEl.innerHTML = state.mixSelections.map(function(p, i) {
      return '<button class="mix-slot' + (i === state.editingSlot ? ' editing' : '') + '" data-idx="' + i + '" aria-label="H\u00f6schen ' + (i+1) + ': ' + (p.alt || p.handle) + '">' +
        '<span class="mix-slot-num">' + (i+1) + '</span>' +
        '<img src="' + (p.thumb || p.src) + '" alt="" width="52" height="52">' +
      '</button>';
    }).join('');

    /* Step hint + counter */
    if (hintEl) {
      if (state.editingSlot >= 0) {
        hintEl.textContent = 'Schritt 2: Muster f\u00fcr H\u00f6schen ' + (state.editingSlot + 1) + ' w\u00e4hlen';
      } else {
        hintEl.textContent = total + ' von ' + total + ' gew\u00e4hlt \u00b7 Tippe auf ein H\u00f6schen zum \u00c4ndern';
      }
    }

    if (state.editingSlot >= 0 && pickerEl && images) {
      pickerEl.hidden = false;
      pickerEl.innerHTML = '<p class="mix-step-label">Schritt 1: H\u00f6schen oben antippen \u2192 Schritt 2: Muster hier w\u00e4hlen</p>' +
        images.map(function(p) {
        var selected = state.mixSelections[state.editingSlot] && state.mixSelections[state.editingSlot].handle === p.handle;
        return '<button class="mix-pick' + (selected ? ' selected' : '') + '" data-handle="' + p.handle + '" aria-label="' + (p.alt || p.handle) + '">' +
          '<img src="' + (p.thumb || p.src) + '" alt="" width="44" height="44">' +
        '</button>';
      }).join('');
    } else if (pickerEl) {
      pickerEl.hidden = true;
    }
  }

  function updateMixProperty() {
    if (!mixProperty) return;
    var names = state.mixSelections.map(function(p) {
      return p.alt || p.handle || 'Muster ' + (state.mixSelections.indexOf(p) + 1);
    });
    var val = names.filter(function(n) { return n && n.trim().length > 0; }).join(', ');
    mixProperty.value = val || 'Sch\u00f6nste Mischung';
  }

  var mixSlotsEl = $('#mix-slots');
  if (mixSlotsEl) {
    mixSlotsEl.addEventListener('click', function(e) {
      var slot = e.target.closest('.mix-slot');
      if (!slot) return;
      state.editingSlot = parseInt(slot.dataset.idx, 10);
      renderMixSlots();
    });
  }

  var mixPickerEl = $('#mix-picker');
  if (mixPickerEl) {
    mixPickerEl.addEventListener('click', function(e) {
      var pick = e.target.closest('.mix-pick');
      if (!pick || state.editingSlot < 0 || !images) return;
      var p = null;
      for (var i = 0; i < images.length; i++) {
        if (images[i].handle === pick.dataset.handle) { p = images[i]; break; }
      }
      if (p) {
        state.mixSelections[state.editingSlot] = p;
        if (state.editingSlot < state.mixSelections.length - 1) {
          state.editingSlot++;
        } else {
          state.editingSlot = -1;
        }
        renderMixSlots();
        updateMixProperty();
      }
    });
  }

  $$('.mix-mode').forEach(function(btn) {
    btn.addEventListener('click', function() {
      state.mixMode = btn.dataset.mode;
      if (mixModeProperty) {
        mixModeProperty.value = state.mixMode === 'auto' ? 'Sch\u00f6nste Mischung' : 'Eigene Zusammenstellung';
      }
      setActive(btn.parentElement, '.mix-mode', btn);
      var customEl = $('#mix-custom');
      if (state.mixMode === 'custom') {
        if (customEl) customEl.hidden = false;
        buildMixSlots();
      } else {
        if (customEl) customEl.hidden = true;
        var meta = BUNDLE_META[state.bundle];
        state.mixSelections = getAutoMix(meta ? meta.qty : 6);
        updateMixProperty();
      }
    });
  });

  /* ==========================================
     PRODUCT: ADD TO CART
     ========================================== */
  var addingToCart = false;

  function addToCart(e) {
    if (e) e.preventDefault();
    if (addingToCart) return;

    var v = findVariant();
    if (!v || !v.available) return;

    addingToCart = true;
    var addBtn = $('#add-to-cart');
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.textContent = 'Wird hinzugef\u00fcgt...';
    }

    var body = {
      id: v.id,
      quantity: 1,
      properties: {
        'Auswahl': state.mixMode === 'auto' ? 'Sch\u00f6nste Mischung' : 'Eigene Zusammenstellung',
        'Muster': mixProperty ? mixProperty.value : ''
      }
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function(res) {
      if (!res.ok) {
        return res.json().then(function(data) {
          throw new Error(data.description || 'Fehler beim Hinzuf\u00fcgen');
        });
      }
      return res.json();
    })
    .then(function() {
      animateAddButton();
      animateBadge();
      return refreshCart().then(function() { openCart(); }).catch(function() { openCart(); });
    })
    .catch(function(err) {
      console.error('Cart add error:', err);
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.textContent = err.message || 'Fehler, bitte erneut versuchen';
        setTimeout(function() {
          addBtn.textContent = 'In den Warenkorb';
        }, 3000);
      }
    })
    .finally(function() {
      addingToCart = false;
    });
  }

  function animateAddButton() {
    var btn = $('#add-to-cart');
    if (!btn) return;
    btn.classList.add('added');
    btn.disabled = false;
    btn.textContent = 'Hinzugef\u00fcgt \u2713';
    setTimeout(function() {
      btn.classList.remove('added');
      btn.textContent = 'In den Warenkorb';
    }, 1200);
  }

  function animateBadge() {
    if (!cartBadge) return;
    cartBadge.classList.remove('bounce');
    void cartBadge.offsetWidth;
    cartBadge.classList.add('bounce');
  }

  if (productForm) {
    productForm.addEventListener('submit', addToCart);
  }

  /* ==========================================
     PRODUCT: TABS
     ========================================== */
  $$('.tab-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var panelId = btn.getAttribute('aria-controls');
      $$('.tab-btn').forEach(function(t) {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');
      $$('.tab-panel').forEach(function(p) {
        p.classList.remove('active');
        p.hidden = true;
      });
      var panel = document.getElementById(panelId);
      if (panel) {
        panel.classList.add('active');
        panel.hidden = false;
      }
    });
  });

  /* ==========================================
     PRODUCT: FAQ ACCORDION (exclusive)
     ========================================== */
  $$('.faq-item').forEach(function(item) {
    item.addEventListener('toggle', function() {
      if (item.open) {
        $$('.faq-item').forEach(function(other) {
          if (other !== item) other.open = false;
        });
      }
    });
  });

  /* ==========================================
     PRODUCT: INIT
     ========================================== */
  updateVariant();
  buildMixSlots();
  setupRadiogroupKeys(document.querySelector('.swatches'), '.swatch');
  setupRadiogroupKeys(document.querySelector('.sizes'), '.size-btn');
  setupRadiogroupKeys(document.querySelector('.bundles'), '.bundle-card');

})();
